import React from 'react'
import TextField from '@mui/material/TextField';
import Country from './Country'
import State from './State'
import CountryEnum from '../../enums/Country'
import AddressValidator from './AddressValidator';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';

export default ({
  enabled = true,
  allowedCountries,
  country,
  countryName,
  countryOnChange,
  countryErrors,
  insertAddressManually,
  insertAddressManuallyName,
  handleInsertAddressManuallyChange,
  addressValidatorName,
  handleAddressValidation,
  currentValidationStatus,
  showInvalidAddressAlert,
  addressLine1,
  addressLine1Name,
  addressLine1Errors,
  addressLine1OnChange,
  addressLine2,
  addressLine2Name,
  addressLine2Errors,
  addressLine2OnChange,
  addressLine3,
  addressLine3Name,
  addressLine3Errors,
  addressLine3OnChange,
  city,
  cityName,
  cityErrors,
  cityOnChange,
  state,
  stateName,
  stateErrors,
  stateOnChange,
  postcode,
  postcodeName,
  postcodeErrors,
  postcodeOnChange,
  excludedCountries = [],
}) => {
  if (!enabled) {
    return null
  }

  const isExcludedCountry = excludedCountries.some(excludedCountry => excludedCountry.countryCode === country)

  return (
    <div>
      <div className="row">
        <div className="col-xs-12 col-sm-4">
          <Country
            name={countryName}
            errors={!!countryErrors}
            onChange={countryOnChange}
            value={country}
            allowedCountries={allowedCountries}
          />
        </div>
      </div>

      {country && country.toUpperCase() !== 'N/A' && !isExcludedCountry && (
        <div className="row">
          <div className="col-xs-12 col-sm-8">
            <AddressValidator
              name={addressValidatorName} 
              country={country} 
              currentAddress={addressLine1} 
              currentValidationStatus={currentValidationStatus} 
              handleAddressValidation={handleAddressValidation}
              disabled={insertAddressManually} 
            />
          </div>
          <div className='col-xs-12 col-sm-4'>
            <FormGroup>
              <FormControlLabel 
                control={
                  <Checkbox
                    name={insertAddressManuallyName}
                    className="checkbox"
                    checked={insertAddressManually}
                    onChange={handleInsertAddressManuallyChange}
                  />
                }
                label="Insert address manually"
              />
            </FormGroup>
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-xs-12 col-sm-4">
          <TextField
            name={addressLine1Name}
            error={!!addressLine1Errors}
            helperText={addressLine1Errors}
            label="Address Line 1"
            fullWidth
            onChange={addressLine1OnChange}
            type="text"
            value={addressLine1}
            autoComplete="address-line1"
            variant="standard"
            disabled={!insertAddressManually && !isExcludedCountry}
          />
        </div>
        <div className="col-xs-12 col-sm-8">
          <TextField
            name={addressLine2Name}
            error={!!addressLine2Errors}
            helperText={addressLine2Errors}
            label="Address Line 2"
            fullWidth
            onChange={addressLine2OnChange}
            type="text"
            value={addressLine2}
            autoComplete="address-line2"
            variant="standard"
            disabled={!insertAddressManually && !isExcludedCountry}
          />
        </div>
        {country !== CountryEnum.Australia ? (
          <div className="col-xs-12 col-sm-8">
            <TextField
              name={addressLine3Name}
              error={!!addressLine3Errors}
              helperText={addressLine3Errors}
              label="Address Line 3"
              fullWidth
              onChange={addressLine3OnChange}
              type="text"
              value={addressLine3}
              autoComplete="address-line3"
              variant="standard"
              disabled={!insertAddressManually && !isExcludedCountry}
            />
          </div>
        ) : null}
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-4">
          <TextField
            name={cityName}
            error={!!cityErrors}
            helperText={cityErrors}
            label={
              country === CountryEnum.Australia
                ? 'Suburb'
                : 'Suburb / City / District'
            }
            fullWidth
            onChange={cityOnChange}
            type="text"
            value={city}
            autoComplete="address-level2"
            variant="standard"
            disabled={!insertAddressManually && !isExcludedCountry}
          />
        </div>
        <State
          name={stateName}
          className="col-xs-12 col-md-4"
          countryCode={country}
          value={state}
          errors={!!stateErrors}
          onChange={stateOnChange}
          disabled={!insertAddressManually && !isExcludedCountry}
        />
        <div className="col-xs-12 col-md-4">
          <TextField
            name={postcodeName}
            error={!!postcodeErrors}
            helperText={postcodeErrors}
            label={
              country === CountryEnum.Australia ? 'Postcode' : 'Postcode / ZIP'
            }
            fullWidth
            onChange={postcodeOnChange}
            type="text"
            value={postcode}
            autoComplete="postal-code"
            variant="standard"
            disabled={!insertAddressManually && !isExcludedCountry}
          />
        </div>
      </div>
      {currentValidationStatus !== 'VALID' && showInvalidAddressAlert ? <span className="form-error">* Unverified Address: Please use the 'Find Address' field to verify your address. *</span> : false}
    </div>
  )
}
